import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  background: ${props => props.theme.light};
`
